var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoReset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_reset",
    d: "M.406.722a.6.6,0,0,1,.729.146L2.49,2.211A8.085,8.085,0,0,1,5.036.581,7.892,7.892,0,0,1,11.1.638a7.9,7.9,0,0,1,4.26,4.26,7.9,7.9,0,0,1,0,6.208,7.9,7.9,0,0,1-4.26,4.26A7.783,7.783,0,0,1,8,16a7.943,7.943,0,0,1-3.406-.755,7.821,7.821,0,0,1-2.75-2.13.342.342,0,0,1-.078-.234.289.289,0,0,1,.1-.214l1.427-1.437a.4.4,0,0,1,.26-.094.324.324,0,0,1,.24.125,5.3,5.3,0,0,0,6.276,1.651,5.281,5.281,0,0,0,2.844-2.844,5.278,5.278,0,0,0,0-4.135,5.282,5.282,0,0,0-2.844-2.844A5.2,5.2,0,0,0,8,2.67,5.176,5.176,0,0,0,4.364,4.1L5.8,5.534a.593.593,0,0,1,.146.719.623.623,0,0,1-.615.417H.666a.641.641,0,0,1-.469-.2A.641.641,0,0,1,0,6V1.336A.623.623,0,0,1,.406.722Z",
    transform: "translate(0 -.003)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoReset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_reset.2c5e10652e2a1ffca345fb9db95a45b7.svg";